// extracted by mini-css-extract-plugin
export default {"winResultLayer":"bj_bk","winResultLayer__wrapper":"bj_bl","youWinResult_layer_wrapper":"bj_bm"};